import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { PagePath } from 'shared/constants/pagePath';
import { PlantDesignConstants } from 'plantDesign/constants/plantDesignConstants';
import { PlantItemConstants } from 'plantItemNew/constants/plantItemConstants';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import { Col, ComponentLoader, Row } from '@snsw/react-component-library';
import { PlantItemRenewalConstants } from 'plantItemRenewal/constants/plantItemRenewalConstants';

export const PaymentCallback = (props) => {
  const application = useSelector((state) => state.application);

  const queryParams = new URLSearchParams(location.search);
  const completionReference = queryParams.get('completionReference');

  const navigate = useNavigate();

  useEffect(() => {
    if (!completionReference) return;

    if (application.licenceType === PlantItemConstants.licenceType) {
      navigate(PagePath.confirmation);
    } else if (application.licenceType === PlantDesignConstants.licenceType) {
      navigate(PagePath.plantDesignConfirmation);
    } else if (application.licenceType === PlantItemRenewalConstants.licenceType) {
      navigate(PagePath.plantItemRenewalConfirmation);
    }
  }, []);

  return (
    <>
      <Row>
        <Col span={12}>
          <ComponentLoader fullPage />
        </Col>
      </Row>
    </>
  );
};
